
const upAnimation = {
  bind(el, binding) {
    el.style.position = 'relative'
    el.style.bottom = '-100px'
    el.style.opacity = '0'
    el.style.transition = 'all 0.5s ease-out'
  },
  inserted(el) {
    if (IntersectionObserver) {
      upAnimation.observe(el)
    } else {
      upAnimation.listenerScroll(el)
    }
  },
  // 设置元素宽高
  setDomFn(el) {
    el.style.bottom = '0'
    el.style.opacity = '1'
  },
  // 利用IntersectionObserver监听el
  observe(el) {
    var io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        upAnimation.setDomFn(el)
      }
    })
    io.observe(el)
  },
  // 监听scroll事件
  listenerScroll(el) {
    const handler = upAnimation.throttle(upAnimation.setScroll, 300)
    window.addEventListener('scroll', () => {
      handler(el)
    })
  },
  // 计算滚动条的滚动距离-以判断是否出现在屏幕中
  setScroll(el) {
    const windowHeight = document.documentElement.clientHeight
    const elTop = el.getBoundingClientRect().top
    const elBtm = el.getBoundingClientRect().bottom
    if (elTop - windowHeight < 0 && elBtm > 0) {
      upAnimation.setDomFn(el)
    }
  },
  // 节流
  throttle(fn, delay) {
    let timer
    let prevTime
    return function (...args) {
      const currTime = Date.now()
      const context = this
      if (!prevTime) prevTime = currTime
      clearTimeout(timer)

      if (currTime - prevTime > delay) {
        prevTime = currTime
        fn.apply(context, args)
        clearTimeout(timer)
        return
      }

      timer = setTimeout(function () {
        prevTime = Date.now()
        timer = null
        fn.apply(context, args)
      }, delay)
    }
  },
  unbind(el) {
  }
}

export default upAnimation
